import { render, staticRenderFns } from "./DocumentationView.vue?vue&type=template&id=4ac1e055&scoped=true&"
import script from "./DocumentationView.vue?vue&type=script&lang=js&"
export * from "./DocumentationView.vue?vue&type=script&lang=js&"
import style0 from "./DocumentationView.vue?vue&type=style&index=0&id=4ac1e055&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac1e055",
  null
  
)

export default component.exports